/* unplugin-vue-components disabled */import script from "./GiftTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftTable.vue?vue&type=script&setup=true&lang=js"

import "./GiftTable.vue?vue&type=style&index=0&id=413cbc12&lang=css"

const __exports__ = script;

export default __exports__